export default "__VITE_ASSET__BvX_eb2o__"